class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-showcase__slide'));
    if (this.slides.length < 2) return;

    this.duration = parseInt(this.dataset.duration, 10) || 5000;
    this.current = 0;

    this.interval = setInterval(() => this.next(), this.duration);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  next() {
    this.slides[this.current].classList.remove('is-active');
    this.current = (this.current + 1) % this.slides.length;
    this.slides[this.current].classList.add('is-active');
  }
}

customElements.define('hero-slideshow', HeroSlideshow);
